// Safe-content mode ("mode segur"): activated when the site is opened with
// ?app=1 (used by the Google Play WebView app). While active, all +18
// content and options are hidden, regardless of the user's settings.
// The flag is persisted in localStorage so it survives in-app navigation,
// and every API request carries an X-Safe-Mode header so the backend also
// filters +18 content server-side.

const KEY = 'alb_safe_mode';

export function initSafeMode() {
    try {
        const params = new URLSearchParams(window.location.search);
        if (params.get('app') === '1') {
            localStorage.setItem(KEY, '1');
        } else if (params.get('app') === '0') {
            localStorage.removeItem(KEY);
        }
    } catch {
        // localStorage unavailable: ignore, mode simply won't persist.
    }
}

export function isSafeMode() {
    try {
        return localStorage.getItem(KEY) === '1';
    } catch {
        return false;
    }
}
